import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import {MAT_DIALOG_DATA,  MatDialogRef } from '@angular/material/dialog';

@Component({
    templateUrl: './intent-setting-alert-modal.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class IntentSettingAlertModalComponent {
    constructor(
        private readonly matDialogRef: MatDialogRef<IntentSettingAlertModalComponent>,
        @Inject(MAT_DIALOG_DATA) public readonly data: any,
    ) { }

    onConfirmation(isConfirm: boolean): void {
        this.matDialogRef.close(isConfirm);
    }
}
